import {
  ENABLE_MODULE_MASTER_STORAGE_KEY,
  MODULE_ID_STORAGE_KEY,
} from 'constants/common.const';
import { MODULE_ID } from 'constants/photo.const';
import {
  PrintingPhotoRouteConst,
  SelfeRouteConst,
} from 'constants/route.const';
import ModuleMaster from 'containers/_module-master/ModuleMaster';
import { getLocalStorage } from 'helpers/common.helper';
import { isEqualVal } from 'helpers/string.helper';
import React, { ComponentClass } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface WithAuthenticateOption {
  isEnabled?: boolean;
  needAuthenticated?: boolean;
  unMatchingRedirect?: string;
}

const DefaultRedirectTo = {
  pathname: PrintingPhotoRouteConst.START_PAGE,
};

// Todo: refactor code
export default function withModuleMaster(
  InnerComponent: ComponentClass<any> | React.FC,
  customOptions?: WithAuthenticateOption,
): React.FC {
  const { isEnabled = false } = customOptions || {};
  const WithAuthenticate: React.FC = (props: any) => {
    const { ...otherProps } = props;
    const selectedModuleId = getLocalStorage(MODULE_ID_STORAGE_KEY);
    const { pathname } = useLocation();

    localStorage.setItem(
      ENABLE_MODULE_MASTER_STORAGE_KEY,
      isEnabled ? '1' : '',
    );

    if (isEnabled) {
      if (!selectedModuleId) {
        return <ModuleMaster />;
      }

      if (
        isEqualVal(selectedModuleId, MODULE_ID.PRINTING_BOOTH) &&
        isEqualVal(pathname, SelfeRouteConst.START_PAGE)
      ) {
        return <Navigate to={DefaultRedirectTo} />;
      }
    }

    return <InnerComponent {...otherProps} />;
  };

  return WithAuthenticate;
}
